/**
 * The address a sign-in link was sent to. Firebase needs it again to finish
 * the sign-in; keeping it in this browser means the player isn't asked to
 * retype it when they open the link on the same device.
 */
export const EMAIL_FOR_SIGN_IN_KEY = 'kaeliux-email-for-sign-in';

export function rememberEmailForSignIn(email: string): void {
    try {
        localStorage.setItem(EMAIL_FOR_SIGN_IN_KEY, email);
    } catch {
        // Storage blocked: the link page will ask for the address instead.
    }
}

export function storedEmailForSignIn(): string | null {
    try {
        return localStorage.getItem(EMAIL_FOR_SIGN_IN_KEY);
    } catch {
        return null;
    }
}

export function forgetEmailForSignIn(): void {
    try {
        localStorage.removeItem(EMAIL_FOR_SIGN_IN_KEY);
    } catch {
        // Nothing stored that we could remove.
    }
}
